import React, { useMemo, useState } from 'react'
import { ICustomerItem, IOrderItem } from '../../../../../modules/API/Drivers/models/kavData'
import styled, { css, keyframes } from 'styled-components'
import EditIcon from '../../../../../generic/icons/IconLib/PencilIcon'
import ErrorIcon from '../../../../../generic/icons/IconLib/AlertCircleIcon'
import InvoiceIcon from '../../../../../generic/icons/IconLib/InvoiceIcon'
import PackageIcon from '../../../../../generic/icons/IconLib/PackageBoxIcon'
import PalletIcon from '../../../../../generic/icons/IconLib/PalletIcon'
import ScalesIcon from '../../../../../generic/icons/IconLib/ScaleIcon'
import UserIcon from '../../../../../generic/icons/IconLib/UserIcon'
import { useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'
import ColumnOrderElement from './ColumnOrderElement'

interface IProps extends ICustomerItem {
    item: ICustomerItem
    index: number;
    area: number;
    ordersAllowToShow: number[];
    handleSelectToDrag: (elementID: number, kavID: number, CustomerID: number, OrderID: number, isOrder?: boolean
    ) => void;
    handleClickSelectOrder: (item: IOrderItem, area: number, CustomerID: number) => void;
    isMergeTarget?: boolean;
}

const ColumClientElem = ({
    item, index, CustomerID, area, Orders, PO_Num, Customer_Name,
    ordersAllowToShow, handleSelectToDrag, Type, handleClickSelectOrder,
    __dragId, isMergeTarget
}: IProps) => {
    const [isOpen, setIsOpen] = useState<boolean>(false);
    const isPackageOrder = useMemo(() => Orders.length === 0 && PO_Num !== 0, [Orders, PO_Num])
    const isProblem = useMemo(() => Orders.every(order => order.IsProblem), [Orders])
    const {
        weightCurrent, palletsCurrent, packageQty
    } = useMemo(() => {
        if (isPackageOrder) return { weightCurrent: 0, palletsCurrent: 0, packageQty: 0 }

        let reduced = Orders.reduce((acc: Record<string, number>, cur) => {

            if (!ordersAllowToShow.some(e => e === cur.Status)) {
                acc.weight = (acc.weight ? acc.weight : 0) + (cur.Weight || 0)
                acc.pallets = (acc.pallets ? acc.pallets : 0) + (cur.Pallets || 0)
                acc.packageQty = (acc.packageQty ? acc.packageQty : 0) + (cur.Packs || 0)


            } else {
                let palletData = cur.PalletsList.reduce((palletsResult: Record<string, number>, pallet) => {
                    palletsResult.weight = (palletsResult.weight ? palletsResult.weight : 0) + pallet.Gross
                    palletsResult.pallets = (palletsResult.pallets ? palletsResult.pallets : 0) + pallet.PallQty
                    palletsResult.packageQty = (palletsResult.packageQty ? palletsResult.packageQty : 0) + pallet.Qty

                    return palletsResult
                }, {})
                acc.weight = (acc.weight ? acc.weight : 0) + (palletData.weight || 0)
                acc.pallets = (acc.pallets ? acc.pallets : 0) + (palletData.pallets || 0)
                acc.packageQty = (acc.packageQty ? acc.packageQty : 0) + (palletData.packageQty || 0)

                // console.log(palletData.weight)
            }
            return acc
        }, {})
        return { weightCurrent: Math.round(reduced.weight), palletsCurrent: Math.ceil(reduced.pallets), packageQty: reduced.packageQty }
    }, [isPackageOrder, ordersAllowToShow, Orders])

    const handleOpen = () => {
        setIsOpen(!isOpen);
    }
    const handleBlock = (e: React.MouseEvent) => {
        e.stopPropagation()
    }
    const isExistRemark = useMemo(() => {
        return Orders.some(order => order.DistributNote.trim())
    }, [Orders])
    const isRehesh = Type === 1
    const isPalletsExist = useMemo(() => Orders.filter(order => ordersAllowToShow.some(e => e === order.Status)), [Orders, ordersAllowToShow])
    const colorOrderIcon = isPalletsExist.length === 0 ? 'tomato' : isPalletsExist.length === Orders.length ? '#80e081' : 'orange'

    const sortableId = __dragId ?? `${CustomerID} ${area}`
    const sortable = useSortable({
        id: sortableId,
        data: { customerID: CustomerID, areaID: area },
    })
    const sortableStyle: React.CSSProperties = {
        transform: CSS.Transform.toString(sortable.transform),
        transition: sortable.transition,
        opacity: sortable.isDragging ? 0.5 : 1,
    }

    return (
                    <MainWrapper
                        ref={sortable.setNodeRef}
                        style={sortableStyle}
                        {...sortable.attributes}
                        {...sortable.listeners}
                        onClick={handleOpen}
                        $bg={!isRehesh}
                        tabIndex={-1}
                        $mergeTarget={isMergeTarget}
                    >
                        <TitleWrapper>
                            {
                                isExistRemark && (
                                    <ArizotIconWrapper>
                                        <EditIcon />
                                    </ArizotIconWrapper>
                                )
                            }
                            <TitleRow>
                                <TitleItem>
                                    <UserIcon />
                                    {Customer_Name}
                                </TitleItem>
                            </TitleRow>
                            {
                                isProblem ?
                                <TitleRow>
                                    <TitleItem $color='tomato'>
                                        <ErrorIcon />
                                        {Orders.length}
                                    </TitleItem>
                                    <TitleItem>
                                    זיכוים והחזרות
                                    </TitleItem>
                                </TitleRow>
                                :
                                !isPackageOrder ?
                                <>
                                    <TitleRow>
                                        <TitleItem $color={colorOrderIcon}>
                                            <InvoiceIcon />
                                            {Orders.length}
                                        </TitleItem>
                                        <TitleItem $isBold>
                                            <PalletIcon />
                                            {palletsCurrent}
                                        </TitleItem>
                                    </TitleRow>
                                    <TitleRow>
                                        <TitleItem>
                                            <PackageIcon />
                                            {packageQty}
                                        </TitleItem>
                                        <TitleItem>
                                            <ScalesIcon />
                                            {weightCurrent}
                                        </TitleItem>
                                        {
                                            PO_Num !== 0 && isRehesh &&
                                            <TitleItem $isAriza $color='tomato'>
                                                <PackageIcon />
                                            </TitleItem>
                                        }
                                    </TitleRow>
                                </>
                                :
                                <TitleRow>
                                    <TitleItem $isBold>
                                        <PackageIcon />
                                     אריזה ריקה
                                    </TitleItem>
                                </TitleRow>
                            }
                        </TitleWrapper>
                        {
                            isOpen && !isPackageOrder &&
                            <BodyWrapper
                                onClick={handleBlock}
                            >
                                <BodyTitle>
                                    הזמנות:
                                </BodyTitle>
                                {Orders.map((item, index) =>

                                    <ColumnOrderElement
                                        {...item}
                                        key={item.OrderID + area.toString()}
                                        item={item}
                                        ordersAllowToShow={ordersAllowToShow}
                                        handleSelectToDrag={handleSelectToDrag}
                                        area={area}
                                        CustomerID={CustomerID}
                                        isRehesh={isRehesh}
                                        handleClickSelectOrder={handleClickSelectOrder}
                                    />
                                )}
                            </BodyWrapper>
                        }
                    </MainWrapper>
    )
}
const mergeWobble = keyframes`
    0%   { transform: scale(1) rotate(0deg); }
    25%  { transform: scale(1.03) rotate(-1deg); }
    50%  { transform: scale(1.04) rotate(0deg); }
    75%  { transform: scale(1.03) rotate(1deg); }
    100% { transform: scale(1) rotate(0deg); }
`
const MainWrapper = styled.div<{ $bg?: boolean; $mergeTarget?: boolean }>`
position: relative;
    width: 100%;
    display: flex;
    flex-flow: column;
    background: ${props => props.$bg ? '#eff3f4' : '#ccf3cd'} ;
    padding: 0.5em;
    color: #75759e;
    border-radius: 20px;
    gap: 1em;
    transform-origin: center;
    ${props => props.$mergeTarget && css`
        animation: ${mergeWobble} 0.45s ease-in-out infinite;
        box-shadow: 0 0 0 2px rgba(41,127,118,0.9), 0 4px 10px rgba(41,127,118,0.35);
        z-index: 5;
    `}
`
const ArizotIconWrapper = styled.div`
    position: absolute;
    left: 0.3em;
    top: 0.3em;
    width: 2em;
    height: 2em;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #fff;
    border-radius: 50%;
    color: tomato;
`
const TitleWrapper = styled.div`
    width: 100%;
    display: flex;
    flex-flow: column;
    gap: 0.5em;

`
export const TitleRow = styled.div`
    width: 100%;
    display: flex;
    gap: 1em;
    
`
export const TitleItem = styled.div<{ $color?: string, $isBold?: boolean, $isAriza?: boolean }>`
    display: flex;
    gap: 0.5em;
    /* padding-right: ${props => props.$isAriza ? '1em' : '0'}; */
    font-weight: ${props => props.$isBold ? 'bold' : ''};
    svg {
        color: ${props => props.$color ? props.$color : ''}
    }
    &:last-child {
        /* justify-self: flex-start; */
        margin-right: ${props => props.$isAriza ? 'auto' : 'none'};
    }
    
`
const BodyWrapper = styled.div`
    width: 100%;
    display: flex;
    flex-flow: column;
    gap: 0.5em;
    /* border-top: 1px solid gray; */
    border-radius: 20px;
    background: #fff;
    padding: 0.5em 0.2em;

`
const BodyTitle = styled.div`
    width: 100%;
    font-size: 1.1em;
    display: flex;
    justify-content: center;
    
`
export default ColumClientElem